export default "__VITE_ASSET__Duhu_xun__"